import { apiPost } from "../client";
import { useMutation } from "@tanstack/react-query";
import type { IExamReport } from "../exam_papers/getExamReport";

export async function apiGenerateReport(id: string) {
  return apiPost<IExamReport>(`/exam_progress/${id}/report`);
}

export function useMutationGenerateReport() {
  return useMutation({
    mutationFn: (id: string) => apiGenerateReport(id),
  });
}
